










import Vue, { PropOptions } from 'vue';

export type PrototypePage = Blok & {
  sections: Blok[];
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<PrototypePage>,
  },
  methods: {
    gtmTrackStartFree(): void {
      this.$gtm.push({
        event: 'start_free_button_click',
        event_category: 'Button',
        event_action: 'Footer Button Clicked',
      });
    },
  },
});
